<template>
  <div style="padding: 0 10px">
    <div style="display: flex; justify-content: flex-start; align-items: center" class="headerBox">
      <div class="searchbox">
        <div class="infoBox">
          <ScanQuery ph="输入容器号" @onQuery="queryCall" ref="ScanQuery" />
          <el-tag type="warning" effect="dark" v-if="allIncludeFlag === 1">一价全包</el-tag>
          <div style="flex:1">
          </div>
          <div class="limitBox" style="margin-left: 20px">
            重量上限:{{ weightLimit }}kg 美元上限:{{ priceLimit }}美元
          </div>
          <div style="display: flex; margin-left: 20px">
            <!-- <IptNumber placeholder="重量" :value="weight" unit="克" @change="(val) => antiShake(weightSet, val)"
              @enter="weightSet" ref='weightIpt' /> -->
            <IptNumber placeholder="重量" :value="weight" unit="克" @enter="multiWeightSet" ref="weightIpt" />
            <!-- <IptNumber :value="packageNums" placeholder="包裹数量" unit="件" @change="(val) => antiShake(bagNumChange, val)" @enter="bagNumChange" /> -->
          </div>
        </div>
        <div class="splitBox">
          <el-button type="primary" @click="toSplitOrder(true)" :disabled="cansplit < 2">拆包</el-button>
          <div style="width: 440px;">
            <el-select style="margin: 0 10px;width:140px" v-model="boxCode" @change="selectBoxTemplate">
              <el-option v-for="item in boxTemplates" :key="item.boxTemplateId" :label="item.templateName"
                :value="item.boxTemplateId">
              </el-option>
            </el-select>
            <el-input style="width: 80px" placeholder="长" v-model="boxSizeInfo.length"></el-input> *
            <el-input style="width: 80px" placeholder="宽" v-model="boxSizeInfo.width"></el-input> *
            <el-input style="width: 80px" placeholder="高" v-model="boxSizeInfo.height"></el-input>
          </div>
          <div style="flex:1">
            <!-- <div class="publicCustomerTagName" v-if="customerTagName">{{ customerTagName }}</div> -->
            <template v-if="customerTagNameList?.length">
              <div class="publicCustomerTagName" v-for="item in customerTagNameList" :key="item">{{ item }}</div>
            </template>
          </div>
          <el-input maxlength="450" style="width: 300px" v-model="newLogisticsCode" placeholder="手动设置快递单号"
            @change="setShipNumber">
            <template slot="prepend">{{
              expressName ? expressName : "物流公司名字"
              }}</template>
          </el-input>
        </div>
      </div>
      <el-button type="primary" class="headerBtn" style="margin: 0 10px" @click="setShipNumber">提交物流单号</el-button>
      <el-button class="headerBtn" type="success" style="margin-left: auto" @click="multiBuildFinish">
        打包完成
      </el-button>
    </div>
    <div style="display: flex;justify-content: space-between;">
      <div class="warningSpanBox"
        v-html="`当前商品种类数量：<span class='warningSpan'>${skuNum}</span> 种; 总共：<span class='warningSpan'>${totalNum}</span> 个;分拣篮子：<span class='warningSpan'>${query.code}</span>；`">
      </div>
      <el-button v-if="miniFlag === 1" type="warning" style="height: 32px;" :loading="switchBackupLoading"
        @click="switchBackupLogisticsChannel">
        切换物流备选渠道
      </el-button>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单证备注信息</span>
      </div>
      <div style="text-align: left">备注内容：<span style="color:red;font-size: 26px">{{ auditRemark || '-' }}</span></div>
      <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:10px;text-align:left">
        <span>货代公司：{{ expressName || '-' }}</span>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>客户信息</span>
      </div>
      <div style="text-align: left">
        <span style="margin-right: 40px">客户店铺名称：{{ customerShopName }}</span>
        <span>业务担当{{ managerName }}</span>
        <!-- <span>业务备注{{ managerName }}</span> -->
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申报信息</span>
      </div>
      <WmsTable :columns="columns" :hasHeader="false" :is-pagination="false" :dataSource="additionalDataSource">
        <div slot="image" slot-scope="{ text }">
          <img :src="text" alt="" style="width: 60px" />
        </div>
      </WmsTable>
    </el-card>
    <el-card class="box-card">
      <!-- <div slot="header" class="clearfix">

      </div> -->
      <WmsTable :columns="columnsTwo" :hasHeader="false" :scroll="false" :is-pagination="false"
        :dataSource="productDataSource">
        <div slot="productImg" slot-scope="{ text }">
          <img :src="text" alt="" style="width: 60px" />
        </div>
        <div slot="pkgCodeList" slot-scope="{ text }">
          <h6 v-for="item in text" :key="item">{{ item }}</h6>
        </div>
      </WmsTable>
    </el-card>

    <el-dialog title="拆包" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" append-to-body
      class="split" top="10vh">
      <div style="display: flex" v-if="dialogVisible">
        <div style="width: 500px">
          <div class="dialogtitle">剩余未打包商品</div>
          <hr />
          <div style="display: flex; align-items: center; margin: 10px 0">
            <div style="flex-shrink: 0">批次包：</div>
            <el-input ref="filterInput" autofocus v-model="filterInput" placeholder="筛选批次包" style="width: 200px"
              @change="pkgFilterChange">
            </el-input>
            <el-button style="margin-right: 10px;" type="primary" @click="
              pkgFilter = '';
            filterInput = '';
            ">重置</el-button>
            <el-checkbox v-model="autoScan">扫码枪模式</el-checkbox>
          </div>
          <el-table :data="sourcePkgList_onShow" :border="true" style="width: 500px" height="500px">
            <el-table-column prop="pkgCode" label="批次包"></el-table-column>
            <el-table-column prop="shopProductSku" label="SKU"></el-table-column>
            <el-table-column prop="unPackedNums" label="数量"></el-table-column>
            <el-table-column prop="num" label="打包数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.useNum" @blur="numInput(scope.$index)"
                  :ref="`numIpint${scope.row.pkgCode}`"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="felx">
          <el-button type="primary" @click="addPkg" :disabled="addBtnStatus">添加到包裹 <i class="el-icon-arrow-right"></i>
          </el-button>
          <el-button @click="removeTarget" :disabled="removeBtnStatus">移除<i class="el-icon-arrow-left"></i></el-button>
          <el-button type="primary" @click="addLessAll" :disabled="canAddAll">剩余全部添加 <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
        <div style="width: 500px">
          <div class="dialogtitle">已打包商品</div>
          <hr />
          <div style="text-align: left">
            <span v-for="(i, index) in bagList" :key="index">
              <el-tag :closable="bagList.length > 2" :type="index == targetIndex ? '' : 'info'" style="cursor: pointer"
                @click="changeTargetPackageCode(i.deliveryPackageCode)" @close="delBag(index, i.deliveryPackageCode)"
                size="medium">
                {{ `包裹${i.packageNo}` }}
              </el-tag>
            </span>
            <el-tag type="info" @click="addNewBag" size="small"
              :style="!canAddNewBag ? 'cursor: not-allowed' : 'cursor: pointer'">+添加包裹</el-tag>
          </div>
          <div style="
              display: flex;
              align-items: center;
              margin: 10px 0;
              position: relative;
              padding-bottom: 20px;
              width: 220px;
            ">
            <div style="flex-shrink: 0">重量：</div>
            <el-input v-model="bagList[targetIndex].weight" placeholder="请输入" @change="setWeight"
              :class="bagList[targetIndex].weight === '0' ? 'redInput' : ''">
            </el-input><span style="margin-left: 10px">g</span>
            <span style="position: absolute; bottom: -4px; left: 50px; color: red"
              v-if="bagList[targetIndex].weight === '0'">重量不可为0</span>
          </div>
          <el-table :data="bagList[targetIndex].recordList" :border="true" style="width: 500px" height="400px"
            @selection-change="handleSelect">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="pkgCode" label="批次包"></el-table-column>
            <el-table-column prop="shopProductSku" label="SKU"></el-table-column>
            <el-table-column prop="nums" label="数量"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSplit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="物流确认" :visible.sync="detailVisible" width="1200px" :close-on-click-modal="false" append-to-body
      class="split" top="10vh" @before-close="beforeClose" :show-close="false">
      <template #title>
        <div>
          <span class="el-dialog__title">物流确认</span>
          <button type="button" aria-label="close" class="el-dialog__headerbtn" @click="beforeClose">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
      </template>
      <el-table :data="splitDetail" :border="true" height="600px">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.taskDetailList">
              <el-table-column prop="deliveryTaskCode" label="批次包">
                <template slot-scope="detail">
                  <h5 v-for="item in detail.row.pkgCodeList" :key="item">
                    {{ item }}
                  </h5>
                </template>
              </el-table-column>
              <el-table-column prop="productImg" label="商品图片">
                <template slot-scope="detail">
                  <ImgView :src="detail.row.productImg" width="60" height="60" />
                </template>
              </el-table-column>
              <el-table-column prop="productSku" label="商品SKU"></el-table-column>
              <el-table-column prop="realDeliveryNums" label="数量"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryTaskCode" label="包裹号" width="80">
          <template slot-scope="scope">
            <div>包裹{{ scope.row.packageNo }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryTaskCode" label="发货编号"></el-table-column>
        <el-table-column prop="totalWeight" label="包裹重量(g)" width="120"></el-table-column>
        <el-table-column prop="weight2" label="货代公司">
          <template slot-scope="scope">
            <el-select v-model="scope.row.wmsIntForwarderConfigId" placeholder="请选择" filterable
              @change="forwarderChange($event, scope.row, scope.$index)">
              <el-option :label="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
                v-for="item in forwarder" :key="item.intForwarderConfigId" style="max-width: 300px"
                :title="item.forwarder + '-' + item.shippingType"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="logisticsCode" label="物流单号"></el-table-column>
        <el-table-column prop="deliveryTaskCode" label="操作" width="200">
          <template slot-scope="scope">
            <span @click="createWaybillNumber(scope.row)" style="cursor: pointer; color: #409eff">生成物流单号</span>
            |
            <span @click="print(scope.row)" :style="scope.row.logisticsCode
              ? 'cursor: pointer;color:#409eff'
              : 'cursor:not-allowed;color:#999'
              ">打印物流单号</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import ScanQuery from "@/components/ScanQuery";
import IptNumber from "@/components/IptNumber";
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import { audioPay } from "@/utils/tools";
import {
  getSmallBagMultiDetail,
  splitOrder_selectPackage,
  splitOrder_removePackage,
  splitOrder_createPackage,
  splitOrder_getUnpackSku,
  splitOrder_addSku,
  splitOrder_removeSku,
  splitOrder_editWeight,
  splitOrder_confirmSplit,
  splitOrder_detail,
  forwarderList_outStock,
  modifyForwarder,
  getLogisticsNo,
  finishBuildBag,
  setSmallBagWeight,
  getByContainerCode,
  // 切换物流备选渠道接口。
  switchBackupLogisticsChannel,
  getBox,
} from "@/apis/outStock";
import { smallContainer } from "@/views/outOfStock/mixins/smallContainer";
export default {
  name: "SmallMultiBuilding", // 小件多品打包
  mixins: [smallContainer],
  components: {
    ScanQuery,
    IptNumber,
    WmsTable,
    ImgView,
  },
  data() {
    return {
      query: {
        code: "",
        // current: 1,
        // pageSize: 10,
        // total: 0
      },
      deliveryTaskCode: "", // 发货任务编号
      companyCode: "",
      columns: [
        { title: "附加项名称", key: "additionName", dataIndex: "additionName" },
        {
          title: "辅料名称",
          key: "ingredientsName",
          dataIndex: "ingredientsName",
        },
        {
          title: "辅料图片",
          key: "image",
          dataIndex: "image",
          scopedSlots: {
            customRender: "image",
          },
        },
        {
          title: "辅料SKU",
          key: "ingredientsSku",
          dataIndex: "ingredientsSku",
        },
      ],
      columnsTwo: [
        {
          title: "图片",
          key: "productImg",
          dataIndex: "productImg",
          scopedSlots: {
            customRender: "productImg",
          },
        },
        {
          title: "批次包",
          key: "pkgCodeList",
          dataIndex: "pkgCodeList",
          scopedSlots: {
            customRender: "pkgCodeList",
          },
        },
        {
          title: "商品SKU",
          key: "shopProductSku",
          dataIndex: "shopProductSku",
        },
        // { title: "商品名称", key: "productName", dataIndex: "productName" },
        { title: "数量", key: "deliveryNums", dataIndex: "deliveryNums" },
      ],
      customerShopName: "",
      managerName: "",
      additionalDataSource: [],
      productDataSource: [],

      dialogVisible: false,
      sourcePkgList: [],
      filterInput: "",
      pkgFilter: "",
      bagList: [{ bagWeight: undefined }],
      targetPkgList: [],
      targetPackageCode: 0,
      selection: [],

      detailVisible: false,
      splitDetail: [],
      forwarder: [],
      links: [],

      splitPackageFlag: false,
      interceptStatus: false,

      receiverNation: "",
      auditRemark: "",
      boxTemplates: [],
      boxCode: '',
      boxSizeInfo: {},
      customerTagNameList: [],
      autoScan: true,
      allIncludeFlag: 0,
      // 当前接口返回的 mini 标识，用于控制备选渠道按钮显示。
      miniFlag: 0,
      expressName: '',
      // 切换客户备选渠道加载状态。
      switchBackupLoading: false
    };
  },
  computed: {
    //sku种类数量
    skuNum() {
      var skuList = [];
      this.productDataSource.forEach((item) => {
        if (skuList.indexOf(item.productSku) == -1) {
          skuList.push(item.productSku);
        }
      });
      return skuList.length;
    },
    //总商品数
    totalNum() {
      var num = 0;
      this.productDataSource.forEach((item) => {
        num += item.deliveryNums;
      });
      return num;
    },
    sourcePkgList_onShow() {
      return this.sourcePkgList.filter((item) => {
        return (
          item.unPackedNums > 0 &&
          (this.pkgFilter ? item.pkgCode == this.pkgFilter : true)
        );
      });
    },
    targetIndex() {
      return this.bagList.findIndex(
        (item) => item.deliveryPackageCode == this.targetPackageCode
      );
    },
    canAddAll() {
      return this.sourcePkgList.every((item) => item.unPackedNums == 0);
    },
    addBtnStatus() {
      let check = true;
      let reg = /^\+?[1-9]\d*$/;
      this.sourcePkgList.forEach((item, index) => {
        if (item.useNum) {
          if (reg.test(item.useNum)) {
            check = false;
          }
        }
      });
      return check;
    },
    removeBtnStatus() {
      if (
        !this.selection[this.targetIndex] ||
        this.selection[this.targetIndex].length == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    canAddNewBag() {
      let check = false;
      this.sourcePkgList.forEach((item, index) => {
        if (item.unPackedNums > 0) {
          check = true;
        }
      });
      return check;
    },
    cansplit() {
      let num = 0;
      this.productDataSource.forEach((item) => {
        num += item.deliveryNums;
      });
      return num;
    },
    focusTarget() {
      if (this.productDataSource.length) {
        return this.$refs.weightIpt;
      }
      return this.$refs.ScanQuery;
    },
    // targetPkgList_onShow() {
    //   return this.targetPkgList.map(item => {
    //     return item.filter(itemLevel2 => itemLevel2.num > 0)
    //   })
    // }
  },
  mounted() {
    var focusFunc = setInterval(() => {
      if (!this.containerCode || this.dialogVisible || this.detailVisible) {
        return;
      }
      if (!!window.getSelection().toString()) {
        return;
      }
      if (
        document.activeElement.tagName == "INPUT" ||
        document.activeElement.tagName == "TEXTAREA"
      ) {
        return;
      }
      this.$refs.weightIpt.focus();
    }, 300);

    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplates = data;
      }
    });
  },
  beforeUnmount() {
    console.log("beforeUnmount");
    clearInterval(focusFunc);
  },
  methods: {
    queryCall: function (payload) {
      if (!payload.code) {
        this.$message.warning("请扫描条码");
        return;
      }
      this.query.code = payload.code;
      this.getDetails();
    },
    getDetails: function () {
      const that = this;
      forwarderList_outStock().then(({ code, data }) => {
        if (code === 0) {
          that.forwarder = data;
        }
      });
      // 先重置备选渠道按钮状态，避免旧数据残留。
      that.miniFlag = 0;
      const prams = {
        containerCode: that.query.code,
      };
      getByContainerCode(prams).then((res) => {
        console.log(res);
        const { code, data = {} } = res;
        if (code === 0) {
          audioPay(`多品打包`);
          // 解析接口返回的装箱详情和备用渠道标识。
          const {
            deliveryTaskAdditionalDetailList = [],
            taskDetailList = [],
            deliveryTaskCode = "",
            priceLimit,
            weightLimit,
            customerShopName,
            logisticsCompanyCode,
            splitPackageFlag,
            interceptStatus,
            wmsIntForwarderConfigId,
            auditRemark,
            receiverNation,
            managerName,
            customerTagNameList,
            allIncludeFlag,
            wmsForwarder,
            wmsShippingType,
            miniFlag
          } = data;
          that.expressName = [wmsForwarder, wmsShippingType].filter(Boolean).join("-") || "-";
          that.containerCode = that.query.code;
          that.companyCode = logisticsCompanyCode;
          that.wmsIntForwarderConfigId = wmsIntForwarderConfigId;
          that.customerShopName = customerShopName;
          that.managerName = managerName;
          that.additionalDataSource = deliveryTaskAdditionalDetailList;
          that.productDataSource = taskDetailList;
          that.deliveryTaskCode = deliveryTaskCode;
          that.priceLimit = priceLimit;
          that.weightLimit = weightLimit;
          that.splitPackageFlag = splitPackageFlag;
          that.interceptStatus = interceptStatus;
          that.receiverNation = receiverNation;
          that.auditRemark = auditRemark;
          that.customerTagNameList = customerTagNameList
          that.allIncludeFlag = allIncludeFlag
          that.miniFlag = Number(miniFlag) || 0
          // that.sourcePkgList = [{ pkgCode: 123123, SKU: 321, num: 10, useNum: undefined }, { pkgCode: 678000, SKU: 911, num: 10, useNum: undefined }, { pkgCode: 444444, SKU: 757, num: 1, useNum: undefined }]
          // that.targetPkgList = [[...that.cloneTargetItem(that.sourcePkgList)], [...that.cloneTargetItem(that.sourcePkgList)]]
          // that.bagList = [{ show: true, bagWeight: undefined }, { show: true, bagWeight: undefined }]
          that.selection = [[], []];
          this.$refs["weightIpt"].focus();
          that.getLogisticsInfo();
        }
      });
    },
    // 称重
    multiWeightSet: function (val) {
      const that = this;
      if (that.weight == val) {
        return;
      }
      if (isNaN(val)) {
        that.$message.warning("请输入数字");
        return;
      }
      function nextStep() {
        const params = {
          deliveryTaskCode: that.deliveryTaskCode,
          weight: val,
          deliveryBoxId: that.deliveryBoxId,
          insidePackCode: that.insidePackCode,
        };
        setSmallBagWeight(params).then(({ code, data }) => {
          if (code === 0) {
            that.weight = val;
            if (data.needNotice) {
              that.$confirm(data.message, "提示", {
                confirmButtonText: "确认",
                type: "warning",
                cancelButtonText: "取消",
              })
              that.getDetails();
            } else {
              that.$message.success(`重量: ${that.weight} g`);
            }
            if (data.shipIsChanged) {
              return
            }
            console.log(that.splitPackageFlag);
            if (!that.splitPackageFlag) {
              that.multiBuildFinish();
            }
            // !that.splitPackageFlag && that.multiBuildFinish()
          }
        });
      }
      if (val || val === 0) {
        if (val > 200) {
          nextStep()
          return
        }
        setTimeout(() => {
          that.$confirm(`重量${val}克，是否提交`, "提示", {
            confirmButtonText: "确认",
            type: "warning",
            cancelButtonText: "取消",
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
            nextStep()
          });
        }, 100);
      }
    },
    async pkgFilterChange() {
      const list = this.sourcePkgList.filter((item) => {
        return (
          item.unPackedNums > 0 &&
          (this.filterInput ? item.pkgCode == this.filterInput : true)
        );
      });
      if (list.length) {
        this.pkgFilter = this.filterInput;
      } else {
        this.filterInput = "";
        audioPay('无此批次')
        this.$message.warning("无对应批次包");
        return
      }
      if (this.autoScan) {
        const current = list[0]
        let params = {
          deliveryPackageCode: this.targetPackageCode,
          deliveryTaskCode: this.deliveryTaskCode,
          pkgList: [
            {
              nums: 1,
              pkgCode: current.pkgCode,
              shopProductSku: current.shopProductSku,
              orderCode: current.orderCode,
            }
          ],
        };
        const res = await splitOrder_addSku(params)
        if (res.code == 0) {
          this.toSplitOrder(false);
          this.$nextTick(() => {
            this.filterInput = "";
            this.pkgFilter = ''
            this.$refs.filterInput.focus()
          })
          audioPay('添加成功')
        } else {
          audioPay('添加失败')
        }
      }
    },
    cloneTargetItem(list) {
      return list.map((item) => {
        return {
          ...item,
          num: 0,
        };
      });
    },
    async addNewBag() {
      if (!this.canAddNewBag) {
        return;
      }
      let params = {
        deliveryTaskCode: this.deliveryTaskCode,
      };
      let res = await splitOrder_createPackage(params);
      if (res.code == 0) {
        this.toSplitOrder(false);
      }
    },
    delBag(val, deliveryPackageCode) {
      this.$confirm("确定要删除该包裹吗？", "", {
        confirmButtonText: "确认",
        type: "error",
        cancelButtonText: "取消",
      }).then(() => {
        this.targetPackageCode =
          this.targetIndex == 0
            ? this.bagList[1].deliveryPackageCode
            : this.bagList[0].deliveryPackageCode;
        let params = {
          deliveryPackageCode,
        };
        splitOrder_removePackage(params).then(({ code, data }) => {
          if (code == 0) {
            this.toSplitOrder(false);
          }
        });
      });
      // let targetIndex = this.bagList.findIndex(item=>item.deliveryPackageCode = deliveryPackageCode)
      //逻辑删除tag
      // this.bagList[val].show = false
      //释放当前包裹内的批次包
      // this.bagList[targetIndex].forEach((item, index) => {
      //   this.sourcePkgList.forEach(v => {
      //     if (v.pkgCode == item.pkgCode)
      //       v.num += item.num
      //   })
      //   item.num = 0
      // })
      //目标Index响应
      // this.targetIndex = this.bagList.findIndex(item => item.show)
    },
    handleSelect(val) {
      let selection = [...this.selection];
      selection[this.targetIndex] = val;
      this.selection = selection;
    },
    changeTargetPackageCode(PackageCode) {
      if (this.targetPackageCode != PackageCode) {
        this.targetPackageCode = PackageCode;
        this.selection = [];
        this.$refs.filterInput.focus()
      }

    },
    async addPkg() {
      let reg = /^\+?[1-9]\d*$/;
      let params = {
        deliveryPackageCode: this.targetPackageCode,
        deliveryTaskCode: this.deliveryTaskCode,
        pkgList: [],
      };
      let check = true;
      this.sourcePkgList.forEach((item, index) => {
        if (item.useNum) {
          if (!reg.test(item.useNum) || item.useNum > item.unPackedNums) {
            check = false;
          }
          params.pkgList.push({
            nums: item.useNum,
            pkgCode: item.pkgCode,
            shopProductSku: item.shopProductSku,
            orderCode: item.orderCode,
          });
        }
      });
      if (check) {
        const res = await splitOrder_addSku(params)
        if (res.code == 0) {
          this.toSplitOrder(false);
        }
      } else {
        audioPay("数量错误")
        this.$message.warning("打包数量错误");
      }
    },
    removeTarget() {
      if (
        !this.selection[this.targetIndex] ||
        this.selection[this.targetIndex].length == 0
      ) {
        this.$message.warning("请选择批次包");
        return;
      }
      let params = {
        deliveryPackageCode: this.targetPackageCode,
        deliveryTaskCode: this.deliveryTaskCode,
        pkgList: [],
      };
      this.selection[this.targetIndex].forEach((item, index) => {
        params.pkgList.push({
          nums: item.nums,
          pkgCode: item.pkgCode,
          shopProductSku: item.shopProductSku,
          orderCode: item.orderCode,
        });
      });
      splitOrder_removeSku(params).then(({ code }) => {
        if (code == 0) {
          this.toSplitOrder(false);
        }
      });
    },
    addLessAll() {
      //剩余全部加到新包裹里
      let params = {
        deliveryPackageCode: this.targetPackageCode,
        deliveryTaskCode: this.deliveryTaskCode,
        pkgList: [],
      };
      this.sourcePkgList.forEach((item, index) => {
        if (item.unPackedNums > 0) {
          params.pkgList.push({
            nums: item.unPackedNums,
            pkgCode: item.pkgCode,
            shopProductSku: item.shopProductSku,
            orderCode: item.orderCode,
          });
        }
      });
      splitOrder_addSku(params).then(({ code }) => {
        if (code == 0) {
          this.toSplitOrder(false);
        }
      });
    },
    numInput(e) {
      // let reg = /^\+?[1-9]\d*$/
      // let num = this.sourcePkgList[e].num
      // let useNum = this.sourcePkgList[e].useNum
      // let pkgCode = this.sourcePkgList[e].pkgCode
      // if (!reg.test(useNum) || useNum > num) {
      //   this.$refs[`numIpint${pkgCode}`].$refs.input.style.border = '1px #F56C6C solid'
      //   console.log(false)
      // } else {
      //   console.log(true)
      //   this.$refs[`numIpint${pkgCode}`].$refs.input.style.border = '1px #C0C4CC solid'
      // }
      // return false
    },
    setWeight(e) {
      console.log(e);
      let reg = /^\+?[1-9]\d*$/;
      if (!reg.test(e)) {
        this.$message.warning("重量错误");
        this.toSplitOrder(false);
        return;
      }
      let params = {
        deliveryPackageCode: this.targetPackageCode,
        weight: e,
      };
      splitOrder_editWeight(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("更新重量成功");
          this.toSplitOrder(false);
        }
      });
    },
    submitSplit() {
      if (this.sourcePkgList.some((item) => item.unPackedNums != 0)) {
        this.$message.warning("存在商品未装入包裹");
        return;
      }
      if (this.bagList.some((item) => item.weight == 0)) {
        let bag = "";
        this.bagList.forEach((item) => {
          if (item.weight == 0) {
            bag += `包裹${item.packageNo},`;
          }
        });
        bag = bag.slice(0, bag.length - 1);
        this.$message.warning(`${bag}重量为空，请填写重量后再操作`);
        return;
      }
      if (this.bagList.some((item) => item.recordList.length == 0)) {
        let bag = "";
        this.bagList.forEach((item) => {
          if (item.recordList.length == 0) {
            bag += `包裹${item.packageNo},`;
          }
        });
        bag = bag.slice(0, bag.length - 1);
        this.$message.warning(`${bag}为空包裹，请删除后再操作`);
        return;
      }
      let params = {
        deliveryTaskCode: this.deliveryTaskCode,
      };
      splitOrder_confirmSplit(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("成功");
          this.dialogVisible = false;
        }
      });
    },

    toSplitOrder(newTargetPackageCode = false) {
      this.selection = [];
      let params = {
        deliveryTaskCode: this.deliveryTaskCode,
      };
      splitOrder_selectPackage(params).then(({ code, data }) => {
        if (code == 0) {
          this.bagList = data;
          if (newTargetPackageCode) {
            this.targetPackageCode = data[0].deliveryPackageCode;
          }
          this.dialogVisible = true;
          this.$nextTick(() => {
            this.$refs.filterInput.focus()
          })
        }
      });
      splitOrder_getUnpackSku(params).then(({ code, data }) => {
        if (code == 0) {
          data.forEach((item) => {
            item.useNum = "";
          });
          this.sourcePkgList = data;
        }
      });
    },
    getSplitDetail() {
      let params = {
        deliveryTaskCode: this.deliveryTaskCode,
        // deliveryTaskCode: 'GJFH2210241584521117824950272'
      };
      splitOrder_detail(params).then(({ code, data }) => {
        console.log(data);
        if (code == 0) {
          this.detailVisible = true;
          data.forEach((item) => {
            item.oldWmsIntForwarderConfigId = item.wmsIntForwarderConfigId;
          });
          this.splitDetail = data;
        }
      });
      this.companyCode = "";
    },

    async beforeClose() {
      let that = this;
      that
        .$confirm("关闭后需前往国际发货单列表生成运单和打印面单", "", {
          confirmButtonText: "确认",
          type: "error",
          cancelButtonText: "取消",
        })
        .then(() => {
          that.detailVisible = false;
          that.$refs["ScanQuery"].focusIpt();
        });
    },
    forwarderChange(val, record, index) {
      let params = {
        deliveryTaskCode: record.deliveryTaskCode,
        wmsIntForwarderConfigId: val,
      };
      modifyForwarder(params).then(({ code, data }) => {
        if (code === 0) {
          if (data.needNotice) {
            this.$confirm(data.message, "提示", {
              confirmButtonText: "确认",
              type: "warning",
              cancelButtonText: "取消",
            })
          } else {
            this.$message.success("成功");
          }
          this.getSplitDetail();
        } else {
          let data = [...this.splitDetail];
          data[index].wmsIntForwarderConfigId =
            data[index].oldWmsIntForwarderConfigId;
          this.splitDetail = data;
        }
      });
    },
    createWaybillNumber: function (record) {
      let params = {
        deliveryTaskCode: record.deliveryTaskCode,
      };
      getLogisticsNo(params).then(({ code }) => {
        if (code == 0) {
          this.getSplitDetail();
          this.$message.success("操作成功");
        }
      });
    },
    // 切换客户备选渠道并刷新页面数据。
    switchBackupLogisticsChannel: async function () {
      // 当前容器对应的发货任务编号集合。
      const deliveryTaskCodeList = this.deliveryTaskCode ? [this.deliveryTaskCode] : [];
      if (!deliveryTaskCodeList.length) {
        this.$message.warning("缺少发货任务编号");
        return;
      }

      try {
        await this.$confirm("确认切换物流备选渠道？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (e) {
        return;
      }

      this.switchBackupLoading = true;
      try {
        // 切换客户备选渠道接口响应。
        const res = await switchBackupLogisticsChannel(deliveryTaskCodeList);
        if (res.code !== 0) return;

        this.$message.success("切换成功");
        this.getDetails();
      } finally {
        this.switchBackupLoading = false;
      }
    },
    print(record) {
      let that = this;
      console.log(record.wmsIntForwarderConfigId);
      if (record.logisticsTagUrl && record.wmsIntForwarderConfigId) {
        that
          .$printSheet(record.wmsIntForwarderConfigId, [record.logisticsTagUrl])
          .then((res) => { })
          .catch((res) => {
            window.open(
              record.logisticsTagUrl + "?response-content-type=application/pdf"
            );
          });
      } else {
        window.open(
          record.logisticsTagUrl + "?response-content-type=application/pdf"
        );
      }
    },

    multiBuildFinish: function () {
      const that = this;
      // if(!that.packageNums) {
      //     that.$message.error('请填写包裹数！')
      //     return
      // }
      if (that.weight === null) {
        that.$message.error("请填写包裹重量！");
        return;
      }
      if (that.interceptStatus == 1) {
        setTimeout(() => {
          that.$confirm(
            '<div style="color:red">该发货单已被拦截，请单独放置</div>',
            "拦截提示",
            {
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              closeOnPressEscape: false,
            }
          );
        }, 300);
      }
      function openPdf(url) {
        window.open(url + "?response-content-type=application/pdf");
      }
      const arr = Object.keys(that.boxSizeInfo).map(v => that.boxSizeInfo[v])
      if (arr.some(v => v) && arr.some(v => !v)) {
        that.$message.warning('请输入长宽高')
        return
      }
      function errorNum(v) {
        return isNaN(v) || !Number.isInteger(Number(v)) || v < 1
      }
      if (arr.every(v => v) && arr.some(v => errorNum(v))) {
        that.$message.warning('请输入正确的长宽高')
        return
      }
      finishBuildBag({
        deliveryTaskCode: that.deliveryTaskCode,
        ...that.boxSizeInfo
      }).then(
        ({ code, data }) => {
          if (code === 0) {
            audioPay(`完成`);
            that.$refs["ScanQuery"].focusIpt();
            that.$message.success("打包完成");
            that.query.code = "";
            that.weight = "";
            that.additionalDataSource = [];
            that.productDataSource = [];
            that.containerCode = "";
            that.boxSizeInfo = {}
            that.customerTagNameList = []
            that.expressName = ''
            that.miniFlag = 0
            // if (data.logisticsTagUrl) {
            //   if (that.companyCode) {
            //     that.$printSheet(that.companyCode, data.logisticsTagUrl).then(res => {
            //       console.log(res)
            //     }).catch(res => {
            //       openPdf(data.logisticsTagUrl)
            //     })
            //     return
            //   }
            //   openPdf(data.logisticsTagUrl)
            // } else {
            //   this.$message.warning('无物流面单，请线下处理')
            // }
            if (data.hasFinish) {
              this.$message.success("该容器中商品打包完成");
            }
            if (data.splitFlag == 1) {
              that.getSplitDetail();
              return;
            }
            // that.companyCode = ''
          }
        }
      );
    },

    pdfLoaded() {
      let loadingInstance = Loading.service({ text: "加载中" });
      this.$refs.printPdf.print();
      loadingInstance.close();
    },
    // 选中箱子模板
    selectBoxTemplate: function (val) {
      const that = this
      // 当选中固定模板时
      if (!!val && val !== '') {
        that.boxTemplates.forEach(item => {
          if (item.boxTemplateId === val) {
            const { width, length, height } = item
            that.boxSizeInfo = {
              width,
              length,
              height
            }
          }
        })
      }
    },
  },
};
</script>

<style scoped>
::v-deep .box-card .el-card__header {
  background: #f8f8f8;
  padding: 10px 20px !important;
}

.warningSpanBox {
  text-align: left;
}

::v-deep .warningSpan {
  color: red;
  font-size: 80px;
  font-weight: bold;
  line-height: 80px;
}


.box-card {
  margin-bottom: 10px;
}

.clearfix {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.limitBox {
  border: 1px #eee solid;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px 10px;
  color: red;
}

.split {
  font-size: 20px;
}

.dialogTitleSlot {
  width: 100%;
  text-align: left;
}

.dialogtitle {
  font-size: 22px;
  text-align: left;
}

.el-tag {
  margin: 0 10px 6px 0;
}

.felx {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 140px;
}

.felx .el-button {
  width: 110px;
  margin: 6px 0 !important;
}

.redInput ::v-deep input {
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid red !important;
}

#pdf {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: -1;
}

.receiverNation {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
}

.searchbox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
}

.infoBox {
  display: flex;
  align-items: center;
  width: 100%;
}

.headerBox {
  background-color: #ddeeff;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.headerBox .headerBtn {
  height: 80px;
}

.splitBox {
  display: flex;
  flex-shrink: 0;
  text-align: left;
  width: 100%;
}
</style>
